import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Icon,
  Text
} from './styles';

const Item = ({ text }) => (
  <Container>
    <Icon src="/assets/icons/wave/check.svg" />
    <Text>{text}</Text>
  </Container>
);

Item.propTypes = {
  text: PropTypes.string.isRequired
};

export default Item;
